// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1nFQ5","left":"styles_left__N3qIl"};